import { useTimeFormatted } from 'modules/core/hooks/useTimeFormatted'
import { formatToLowerCase } from 'modules/core/lib/formatTime'
import i18n from 'modules/core/lib/i18n'

import { Shift } from 'modules/shift_management/lib/types'
import type ShiftConflicts from 'modules/shift_management/store/internal/collections/ShiftsConflicts'

interface Props {
  shift: Shift
  shiftsConflicts: ShiftConflicts
}

export const toolTipInformation = ({ shift, shiftsConflicts }: Props) => {
  if (shiftsConflicts.hasLeaveConflictByShiftId(shift.id)) {
    return i18n.t('shift_management.conflict.with_leave')
  } else if (shiftsConflicts.hasRestDayConflictByShiftId(shift.id)) {
    return i18n.t('shift_management.conflict.with_rest_day')
  } else {
    return i18n.t('shift_management.conflict.with_shift')
  }
}

export interface Dates {
  startAt: string
  endAt: string
}

export const useFormatDates = () => {
  const formatTime = useTimeFormatted()

  return (shift: Shift, date: moment.Moment, nightShiftPeriodBefore: boolean): Dates => {
    const startAt = formatToLowerCase(formatTime(shift.startTime))
    const endAt = formatToLowerCase(formatTime(shift.endTime))

    if (nightShiftPeriodBefore) {
      return { startAt: '...', endAt }
    }

    if (shift.isOvernightByCalendarDay) {
      const endNightShiftExactMidnight = shift.isEndNightShiftExactMidnight(
        date.clone().add(1, 'day')
      )
      return {
        startAt: shift.isSingleDay || shift.isSameStartDay(date) ? startAt : '...',
        endAt:
          shift.isSingleDay || shift.isSameEndDay(date) || endNightShiftExactMidnight
            ? endAt
            : '...',
      }
    }

    return { startAt, endAt }
  }
}
